import React, { useState } from 'react';
import { Send } from 'lucide-react';
import AdminLoginPopup from './AdminLoginPopup';

interface MessageInputProps {
  onSendMessage: (message: string) => void;
}

const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage }) => {
  const [message, setMessage] = useState('');
  const [showAdminPopup, setShowAdminPopup] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      if (message.toLowerCase() === 'admin') {
        setShowAdminPopup(true);
      } else {
        onSendMessage(message);
      }
      setMessage('');
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="p-3 bg-white rounded-b-3xl border-t border-gray-100">
        <div className="flex items-center bg-gray-50 rounded-full p-1">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Mesajınızı yazın..."
            className="flex-grow px-4 py-2 bg-transparent focus:outline-none text-gray-700 placeholder-gray-500 rounded-full text-sm"
          />
          <button 
            type="submit" 
            className={`ml-1 p-2 rounded-full transition-all transform hover:scale-105 active:scale-95 ${
              message.trim() 
                ? 'bg-gradient-to-r from-red-600 to-red-500 text-white shadow-lg hover:shadow-xl'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
            disabled={!message.trim()}
          >
            <Send className="h-4 w-4" />
          </button>
        </div>
      </form>
      
      {showAdminPopup && (
        <AdminLoginPopup onClose={() => setShowAdminPopup(false)} />
      )}
    </>
  );
};

export default MessageInput;